export default "__VITE_ASSET__DoDZhHe___"